/**
 * Workspace SPA entry point — mounts the root App component into the DOM.
 *
 * @module apps/workspace/main
 * @see TASK-FRONTEND-SCAFFOLD-VITE-CHG-005
 */
// FIRST, above every other import: stash the ?imp= impersonation hint before
// AuthProvider's init effect can fire an auth redirect that drops the query
// string (SPEC-FRONTEND-RULE-095(4), TASK-IMP-AUTHCONTEXT-SPA-WIRING).
import "../../utils/impersonationHint";
// Self-hosted Inter brand font (bundled, same-origin) — see web/src/theme/fonts.ts
import "../../theme/fonts";
import React from "react";
import ReactDOM from "react-dom/client";
import { I18nProvider } from "../../i18n/I18nProvider";
import App from "./App";
import { installStaleChunkRecovery } from "../../utils/staleChunkRecovery";

// A lazy chunk from the previous deploy reloads the page once (TASK-BUGFIX-STALE-CHUNK-ERROR-PAGE).
installStaleChunkRecovery();

// The Workspace App.tsx already wraps itself in ThemeProvider + CssBaseline,
// so we only add I18nProvider and StrictMode here.

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>,
);
